import "../../App.css";
import "./policies.css"; // <-- Asegúrate de que la ruta sea correcta según dónde guardaste el archivo
import { useEffect } from "react";
import MainSection from "../../secciones/MainSection/MainSection";

function TyC() {
  // Scroll al inicio cuando se carga la página
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MainSection />
      <section className="policy-section">
        <div className="container policy-container">
          
          <header className="policy-header">
            <h1 className="title policy-title">
              Política de Devoluciones
            </h1>
            <h2 className="extra_title policy-extra-title">
              Términos y Condiciones
            </h2>
            <p className="subtitle policy-subtitle">
              (Conforme al Código de Protección y Defensa del Consumidor – Ley N° 29571)
            </p>
          </header>

          <article className="description policy-description">
            <p>
              La presente política regula las condiciones aplicables a solicitudes de devolución relacionadas con la contratación de cursos virtuales ofrecidos por <strong>One Learning</strong>.
            </p>

            <h3 className="policy-section-title">1. Naturaleza del servicio</h3>
            <p>
              Los cursos virtuales constituyen servicios digitales de ejecución inmediata, los cuales se brindan a través de acceso a plataformas, contenidos, materiales y/o sesiones en vivo.
            </p>
            <p>
              De conformidad con el artículo 58 del Código de Protección y Defensa del Consumidor, el consumidor reconoce que, al acceder al servicio, este se considera ejecutado, limitando la posibilidad de desistimiento.
            </p>

            <h3 className="policy-section-title">2. Derecho de desistimiento</h3>
            <p>El usuario podrá solicitar la devolución del monto pagado dentro de un plazo máximo de <strong>48 horas</strong> posteriores a la compra, siempre que:</p>
            <ul className="policy-list">
              <li>No haya accedido a la plataforma</li>
              <li>No haya visualizado contenidos</li>
              <li>No haya descargado materiales</li>
              <li>No haya participado en sesiones en vivo</li>
            </ul>

            <h3 className="policy-section-title">3. Restricción de devoluciones</h3>
            <p>
              No procederán devoluciones cuando el servicio haya sido utilizado total o parcialmente, en atención a su naturaleza digital e intangible, conforme a lo dispuesto en el Código de Protección y Defensa del Consumidor.
            </p>

            <h3 className="policy-section-title">4. Cancelación o modificación del servicio</h3>
            <p>En caso One Learning cancele el curso o realice modificaciones sustanciales en su contenido, cronograma o modalidad, el usuario tendrá derecho a elegir entre:</p>
            <ul className="policy-list">
              <li>Reprogramar su participación sin costo adicional, o</li>
              <li>Solicitar la devolución total del monto pagado</li>
            </ul>

            <h3 className="policy-section-title">5. Idoneidad del servicio</h3>
            <p>
              En caso el servicio no cumpla con las condiciones ofrecidas (idoneidad), el usuario podrá presentar un reclamo conforme a la normativa vigente, pudiendo corresponder la devolución total o parcial, según evaluación.
            </p>

            <h3 className="policy-section-title">6. Casos de fuerza mayor</h3>
            <p>
              One Learning podrá evaluar solicitudes de devolución en situaciones excepcionales debidamente sustentadas (salud, emergencias u otros), conforme a criterios de razonabilidad y buena fe.
            </p>

            <h3 className="policy-section-title">7. Procedimiento de solicitud</h3>
            <p>El usuario deberá enviar su solicitud al correo: <a href="mailto:contacto@onelearning.pe" className="policy-link">contacto@onelearning.pe</a>, adjuntando:</p>
            <ul className="policy-list">
              <li>Nombre completo</li>
              <li>Curso adquirido</li>
              <li>Comprobante de pago</li>
              <li>Motivo de la solicitud</li>
            </ul>

            <h3 className="policy-section-title">8. Plazo de reembolso</h3>
            <p>
              De ser aprobada la solicitud, la devolución se realizará en un plazo máximo de <strong>15 días hábiles</strong>, mediante el mismo medio de pago o uno previamente acordado.
            </p>

            <h3 className="policy-section-title">9. Libro de Reclamaciones</h3>
            <p>
              One Learning pone a disposición de sus usuarios el <strong>Libro de Reclamaciones Virtual</strong>, conforme a lo establecido por INDECOPI.
            </p>

            <h3 className="policy-section-title">10. Aceptación</h3>
            <p className="policy-highlight">
              La contratación de los cursos implica la <strong>aceptación expresa</strong> de los presentes términos y condiciones.
            </p>
          </article>
        </div>
      </section>
    </>
  );
}

export default TyC;